import {
    REBOOT_DEVICE_OPEN_MODAL,
    REBOOT_DEVICE_CLOSE_MODAL,
    REBOOT_DEVICE_REQUEST,
    REBOOT_DEVICE_RESULT,
    REBOOT_DEVICE_GET_DEVICE_REQUEST,
    REBOOT_DEVICE_GET_DEVICE_RESULT,
} from 'Redux/actionTypes';

export const rebootDeviceGetDeviceRequest = (data) => ({
    type: REBOOT_DEVICE_GET_DEVICE_REQUEST,
    payload: data,
})

export const rebootDeviceGetDeviceResult = (result) => ({
    type: REBOOT_DEVICE_GET_DEVICE_RESULT,
    payload: result,
})

export const rebootDeviceOpenModal = (data) => ({
    type: REBOOT_DEVICE_OPEN_MODAL,
    payload: data,
})

export const rebootDeviceCloseModal = () => ({
    type: REBOOT_DEVICE_CLOSE_MODAL
})

export const rebootDeviceRequest = (data) => ({
    type: REBOOT_DEVICE_REQUEST,
    payload: data
})

export const rebootDeviceResult = (result) => ({
    type: REBOOT_DEVICE_RESULT,
    payload: result
})